module.exports = __webpack_public_path__ + "static/media/sberbank.3ccaf438.svg";